module.exports = __webpack_public_path__ + "static/media/menu.d67273cc.svg";